module.exports = __webpack_public_path__ + "img/0192-folder-upload.89b06ec2.svg";